import { api } from '@/lib/api/client'
import type { Campaign, FlashDeal } from '@/modules/promo/model/types'

export const promoApi = {
  listCampaigns:  () => api.get<Campaign[]>('/promo/campaigns'),
  listFlashDeals: () => api.get<FlashDeal[]>('/promo/flash-deals'),
  adminListCampaigns:  () => api.get<Campaign[]>('/promo/campaigns'),
  adminCreateCampaign: (p: Omit<Campaign, 'id'>) => api.post<Campaign>('/promo/campaigns', p),
  adminUpdateCampaign: (id: string, p: Partial<Campaign>) => api.patch<Campaign>(`/promo/campaigns/${id}`, p),
  adminDeleteCampaign: (id: string) => api.delete<void>(`/promo/campaigns/${id}`),
  adminListFlashDeals:  () => api.get<FlashDeal[]>('/promo/flash-deals'),
  adminCreateFlashDeal: (p: Omit<FlashDeal, 'id'>) => api.post<FlashDeal>('/promo/flash-deals', p),
  adminUpdateFlashDeal: (id: string, p: Partial<FlashDeal>) => api.patch<FlashDeal>(`/promo/flash-deals/${id}`, p),
  adminDeleteFlashDeal: (id: string) => api.delete<void>(`/promo/flash-deals/${id}`),
}
